//===================================================
// 1.Load,Init,Settings
//===================================================
import React, { useEffect, useState, useCallback } from "react";
import axios from "axios";
import countries from "world-countries";

import { useDispatch } from "react-redux";
import {
  GetRegisterValue,
  GetOutsideRegisterActions,
} from "../../../redux/modules/Register";
import {
  checkPhoneNumber,
  toUpperCaseFirstLetter,
  validateValidEmail,
} from "../../../common/Utility";
import { DEFAULT_COUNTRY_CCA3 } from "../../../common/Constants";

// Material-ui
import {
  Dialog,
  DialogTitle,
  TextField,
  DialogContent,
  Button,
  DialogActions,
  Grid,
  Typography,
  Chip,
  CircularProgress,
  Select,
  MenuItem,
  Box,
} from "@mui/material";

// custom components
import {
  CustomPhoneField,
  CustomSearchLocation,
  ManualAddressForm,
  CustomPasswordInput,
} from "../../atoms";

// css *required
import { useStyles } from "./index.css";

//===================================================
// 2.Main Component
//===================================================
const CreateAccountModal = (props) => {
  // 2-1. useStyles *require
  const classes = useStyles();

  // 2-2. Store
  const { onClose, setSnackBar, userType } = props;
  const dispatch = useDispatch();
  const { isLoading } = GetRegisterValue();
  const [selectedAddress, setSelectedAddress] = useState({
    fullAddress: "",
    street: "",
    suburb: "",
    state: "",
    country: "Australia",
    zipcode: "",
    longitude: "",
    latitude: "",
  });
  const [selectedCountry, setSelectedCountry] = useState(
    DEFAULT_COUNTRY_CCA3
  );
  // const [isLoading, setIsLoading] = useState(false);
  const [showManualAddress, setShowManualAddress] = useState(false);
  const [isSubmit, setIsSubmit] = useState(false);
  const [formErrors, setFormErrors] = useState({});
  const [createAccountForm, setCreateAccountForm] = useState({
    email: "",
    firstname: "",
    lastname: "",
    phone: "",
    password: "",
    confirm_password: "",
    user_type: userType,
    street: "",
    zipcode: "",
    state: "",
    suburb: "",
    longitude: "",
    latitude: "",
    country: "Australia",
    fullAddress: "",
  });

  const resetForm = () => {
    setShowManualAddress(false);
    setCreateAccountForm({
      email: "",
      firstname: "",
      lastname: "",
      phone: "",
      password: "",
      confirm_password: "",
      user_type: userType,
      street: "",
      zipcode: "",
      state: "",
      suburb: "",
      fullAddress: "",
    });
    setIsSubmit(false);
    setFormErrors({});
  };
  useEffect(() => {
    if (Object.keys(formErrors).length === 0 && isSubmit) {
      const submitForm = async () => {
        try {
          const { register } = GetOutsideRegisterActions();
          // const response = await axios.post("/api/users", createAccountForm);
          const response = await register(createAccountForm, dispatch);
          if (response.type === "register/failure") {
            const responseData = response.payload.error.response.data;
            if (responseData.message === "User already exist") {
              setFormErrors({ ...formErrors, email: "Email already exist." });
            }

            if (responseData.message === "Phone number already exist") {
              setFormErrors({
                ...formErrors,
                phoneNumber: "Phone number already exist.",
              });
            }
            return;
          }
          onClose && onClose();
          resetForm();
          setSnackBar({
            isShow: true,
            message: "Created account successfully",
            severity: "success",
          });
        } catch (error) {
          console.log(error);
        }
      };
      submitForm();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- submit gated by formErrors/isSubmit; full deps would resubmit on keystroke
  }, [formErrors, isSubmit]);

  // showMain
  return showMain({
    ...props,
    classes,
    selectedAddress,
    setSelectedAddress,
    selectedCountry,
    setSelectedCountry,
    showManualAddress,
    setShowManualAddress,
    createAccountForm,
    setCreateAccountForm,
    dispatch,
    formErrors,
    setFormErrors,
    isSubmit,
    setIsSubmit,
    userType,
    isLoading,
    // setIsLoading,
  });
};

//===================================================
// 3.Export
//===================================================
export default CreateAccountModal;

//===================================================
// 4.propTypes and defaultProps
//===================================================

//4-1. propTypes
CreateAccountModal.propTypes = {};

//4-2. defaultProps
CreateAccountModal.defaultProps = {};

//===================================================
// 5.Functions *require showMain()
//===================================================
/**
 * Show main
 * @param {*} props
 */
const showMain = (props) => {
  const {
    classes,
    open,
    onClose,
    userType,
    showManualAddress,
    createAccountForm,
    setCreateAccountForm,
    setSelectedAddress,
    selectedAddress,
    selectedCountry,
    setSelectedCountry,
    isLoading,
    formErrors,
  } = props;
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm">
      <DialogTitle align="center">
        Create Account as {userType ? showUserType(props) : ""}
      </DialogTitle>
      <DialogContent>
        <Grid
          container
          rowSpacing={2}
          mt={1}
          columnSpacing={{ xs: 1, sm: 2, md: 2 }}
        >
          <Grid item xs={12}>
            <TextField
              error={formErrors.email ? true : false}
              helperText={formErrors.email}
              type="email"
              name="email"
              value={createAccountForm.email}
              onChange={(event) => {
                handleInputChange(event, props);
              }}
              label="Email"
              fullWidth
            />
          </Grid>
          <Grid item xs={12} sm={6} md={6}>
            <TextField
              error={formErrors.firstname ? true : false}
              helperText={formErrors.firstname}
              type="text"
              name="firstname"
              value={createAccountForm.firstname}
              onChange={(event) => {
                handleInputChange(event, props);
              }}
              label="Firstname"
              fullWidth
            />
          </Grid>
          <Grid item xs={12} sm={6} md={6}>
            <TextField
              error={formErrors.lastname ? true : false}
              helperText={formErrors.lastname}
              type="text"
              name="lastname"
              value={createAccountForm.lastname}
              onChange={(event) => {
                handleInputChange(event, props);
              }}
              label="Lastname"
              fullWidth
            />
          </Grid>
          <Grid item xs={12} sm={12} md={12} align="right">
            <Chip
              label={
                !showManualAddress ? "Add address manually" : "Search Address"
              }
              color="primary"
              variant="outlined"
              size="small"
              onClick={() => handleShowManualAddress(props)}
            />
          </Grid>
          {!showManualAddress && (
            <Grid item xs={12} sm={12} md={12}>
              <SelectCountry
                selectedCountry={selectedCountry}
                setSelectedCountry={setSelectedCountry}
              />
            </Grid>
          )}
          <Grid
            item
            xs={12}
            sm={12}
            md={12}
            className={
              (showManualAddress ? classes.hidden : null) +
              " " +
              classes.customPaddingTop
            }
          >
            <CustomSearchLocation
              setAddress={(address) =>
                setSelectedAddress({ ...selectedAddress, ...address })
              }
              hasError={formErrors.searchAddress}
              type="form"
              selectedCountry={selectedCountry}
            />
          </Grid>
          {showManualAddress ? (
            <Grid
              item
              xs={12}
              sm={12}
              md={12}
              className={classes.customPaddingTop}
            >
              <ManualAddressForm
                street={selectedAddress.street}
                suburb={selectedAddress.suburb}
                state={selectedAddress.state}
                zipcode={selectedAddress.zipcode}
                country={selectedAddress.country}
                setAddress={(address) =>
                  setSelectedAddress({ ...selectedAddress, ...address })
                }
                hasError={formErrors}
              />
            </Grid>
          ) : null}
          <Grid item xs={12} sm={12} md={12}>
            <CustomPhoneField
              setPhoneNumber={(val) =>
                setCreateAccountForm({ ...createAccountForm, phone: val })
              }
              hasError={formErrors.phoneNumber}
              selectedCountry={selectedCountry}
            />
          </Grid>
          <Grid item xs={12}>
            <CustomPasswordInput
              error={formErrors.password ? true : false}
              helperText={formErrors.password}
              name="password"
              value={createAccountForm.password}
              onChange={(event) => {
                handleInputChange(event, props);
              }}
              label="Password"
              fullWidth
            />
          </Grid>
          <Grid item xs={12}>
            <CustomPasswordInput
              error={formErrors.confirmPassword ? true : false}
              helperText={formErrors.confirmPassword}
              name="confirm_password"
              value={createAccountForm.confirm_password}
              onChange={(event) => {
                handleInputChange(event, props);
              }}
              label="Confirm Password"
              fullWidth
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions className={classes.dialogActions}>
        <Button
          type="submit"
          variant="contained"
          onClick={() => {
            handleCreateAccount(props);
          }}
          fullWidth
          disabled={isLoading}
        >
          {isLoading ? (
            <CircularProgress disableShrink={true} size={25} color="inherit" />
          ) : (
            "Create Account"
          )}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

/**
 * Show user type title
 * @param {*} props
 * @returns
 */
const showUserType = (props) => {
  const { userType } = props;
  return (
    <Typography display="inline" variant="h6" component="div" color="#1565c0">
      {userType === "cleaner"
        ? `${
            toUpperCaseFirstLetter("professional") +
            " " +
            toUpperCaseFirstLetter("cleaner")
          }`
        : toUpperCaseFirstLetter(userType)}
    </Typography>
  );
};

/**
 * Validate form
 * @param {*} preparedData
 * @returns
 */
const validateForm = (preparedData, props) => {
  const { showManualAddress, selectedAddress } = props;
  const errors = {};
  if (!preparedData.email) {
    errors.email = "Please enter your email.";
  } else if (!validateValidEmail(preparedData.email)) {
    errors.email = "Please enter valid email.";
  }

  if (!preparedData.firstname) {
    errors.firstname = "Please enter your first name.";
  }

  if (!preparedData.lastname) {
    errors.lastname = "Please enter your last name.";
  }

  if (showManualAddress) {
    if (!selectedAddress.street) {
      errors.street = "Please enter street address.";
    }

    if (!selectedAddress.suburb) {
      errors.suburb = "Please enter a suburb.";
    }

    if (!selectedAddress.state) {
      errors.state = "Please enter a state.";
    }

    if (!selectedAddress.zipcode) {
      errors.zipcode = "Please enter a postcode.";
    } else if (
      !Number(selectedAddress.zipcode) ||
      selectedAddress.zipcode.length > 4
    ) {
      errors.zipcode = "Please enter a valid postcode.";
    }
  } else {
    if (!selectedAddress.fullAddress) {
      errors.searchAddress = "Please select an address";
    }
  }

  if (!preparedData.password) {
    errors.password = "Please enter a password.";
  } else if (preparedData.password.length < 8) {
    errors.password = "Use 8 characters or more for your password";
  }

  if (!preparedData.confirm_password) {
    errors.confirmPassword = "Please confirm your password.";
  } else if (preparedData.password !== preparedData.confirm_password) {
    errors.confirmPassword = "Password did not match.";
  }

  if (!checkPhoneNumber(preparedData.phone)) {
    errors.phoneNumber = "Please enter a valid phone number.";
  }

  return errors;
};

//===================================================
// 6.Actions
//===================================================

/**
 * handle input change
 * @param {*} event
 * @param {*} props
 */
const handleInputChange = (event, props) => {
  const { createAccountForm, setCreateAccountForm } = props;
  let name = event.target.name;
  let value = event.target.value;
  setCreateAccountForm({ ...createAccountForm, [name]: value });
};

/**
 * Create account
 * @param {*} props
 */
const handleCreateAccount = async (props) => {
  const {
    createAccountForm,
    setCreateAccountForm,
    setFormErrors,
    setIsSubmit,
    userType,
    selectedAddress,
  } = props;
  setFormErrors(validateForm(createAccountForm, props));
  setCreateAccountForm({
    ...createAccountForm,
    ...selectedAddress,
    user_type: userType,
  });
  setIsSubmit(true);
};

/**
 * handle show manual address
 * @param {*} props
 */
const handleShowManualAddress = (props) => {
  const { showManualAddress, setShowManualAddress, setSelectedAddress } = props;
  setSelectedAddress({
    fullAddress: "",
    street: "",
    suburb: "",
    state: "",
    country: "Australia",
    zipcode: "",
    longitude: "",
    latitude: "",
  });
  setShowManualAddress(!showManualAddress);
};

//===================================================
// 7. SelectCountry Component
//===================================================
const BACKEND_URL =
  process.env.REACT_APP_BACKEND_URL?.replace(/\/$/, "") ||
  "http://localhost:5000";

const formattedCountries = countries.map((country) => ({
  name: country.name.common,
  cca3: country.cca3,
  countryCode: country.cca2,
  flag: `https://flagcdn.com/w40/${country.cca2.toLowerCase()}.png`,
}));

const SelectCountry = ({ selectedCountry, setSelectedCountry }) => {
  const [loading] = useState(false);

  const fetchUserLocation = useCallback(
    async (latitude, longitude) => {
      try {
        const response = await axios.get(
          `${BACKEND_URL}/api/google-maps/geocode`,
          {
            params: {
              latlng: `${latitude},${longitude}`,
            },
          }
        );

        if (response.data.results.length > 0) {
          const result = response.data.results[0];
          const addressComponents = result.address_components;

          const countryComponent = addressComponents.find((component) =>
            component.types.includes("country")
          );

          const userCountryName = countryComponent?.long_name;
          const matchedCountry = formattedCountries.find(
            (c) => c.name.toLowerCase() === userCountryName?.toLowerCase()
          );

          if (matchedCountry) setSelectedCountry(matchedCountry.cca3);
        }
      } catch (error) {
        console.error("Error fetching user location:", error);
      }
    },
    [setSelectedCountry]
  );

  useEffect(() => {
    if (loading || selectedCountry) return;

    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) =>
          fetchUserLocation(
            position.coords.latitude,
            position.coords.longitude
          ),
        (error) => console.error("Error getting geolocation:", error),
        { enableHighAccuracy: true }
      );
    }
  }, [loading, selectedCountry, fetchUserLocation]);

  return (
    <Box display="flex" alignItems="center" gap={2}>
      <Typography variant="body1" sx={{ minWidth: 120 }}>
        Choose Country:
      </Typography>
      <Select
        id="country-select"
        value={selectedCountry || ""}
        onChange={(e) => setSelectedCountry(e.target.value)}
        displayEmpty
        fullWidth
        MenuProps={{
          PaperProps: {
            sx: { maxHeight: 288, overflowY: "auto", width: 250, mt: 0.5 },
          },
        }}
        renderValue={(selected) => {
          if (!selected) return "Select a Country";

          const selectedCountryObj = formattedCountries.find(
            (country) => country.cca3 === selected
          );
          return (
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              {selectedCountryObj?.flag && (
                <img
                  src={selectedCountryObj.flag}
                  alt={selectedCountryObj.name}
                  style={{ width: 20, height: 15 }}
                />
              )}
              <span>{selectedCountryObj?.name}</span>
            </Box>
          );
        }}
      >
        <MenuItem value="" disabled>
          Select a Country
        </MenuItem>
        {formattedCountries.map(({ cca3, name, flag }) => (
          <MenuItem
            key={cca3}
            value={cca3}
            sx={{ display: "flex", alignItems: "center", gap: 1 }}
          >
            {flag && (
              <img src={flag} alt={name} style={{ width: 20, height: 15 }} />
            )}
            <span>{name}</span>
          </MenuItem>
        ))}
      </Select>
    </Box>
  );
};
